import { useClasses } from '@kanda-libs/ks-design-library';
import { CLASS_NAMES } from './constants';
import CheckListItem from './CheckListItem';

interface CheckListProps {
  isLoading?: boolean;
  items: string[];
  className?: string;
}

const CheckList = ({ isLoading, items, className }: CheckListProps) => {
  const classNames = useClasses(CLASS_NAMES, {
    container: ['.container', className],
  });

  return (
    <div className={classNames.container}>
      {items.map((label) => (
        <CheckListItem key={label} label={label} isLoading={isLoading} />
      ))}
    </div>
  );
};

CheckList.defaultProps = {
  isLoading: false,
  className: undefined,
};

export default CheckList;
